import { isNil } from 'lodash';

type NumberOrString = number | string;

export const isValidValue = (value: unknown): value is NumberOrString =>
  !(isNil(value) || value === '' || typeof value === 'object');
